/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

import logo from "../Image/Densatlogo.png";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      {/* ===== TOP INFO BAR ===== */}
      <div className="dentas-topbar">
        <div className="dentas-container dentas-topbar-inner">
          <div className="dentas-topbar-left">
            <span className="dentas-phone">📞 +91-9899811123</span>
          </div>
          <div className="dentas-topbar-right">
            <a href="mailto:info@company.com" className="dentas-email-btn">
              ✉ EMAIL US :- infodel@densat.com
            </a>
          </div>
        </div>
      </div>

      {/* ===== MAIN NAVBAR ===== */}
      <nav className="dentas-navbar">
        <div className="dentas-container dentas-navbar-inner">
          {/* LOGO */}
          <div className="dentas-nav-logo">
            <NavLink to="/" onClick={closeMenu}>
              <img src={logo} alt="Company Logo" className="dentas-logo-img" />
            </NavLink>
          </div>

          {/* MENU LINKS */}
          <ul className={`dentas-nav-links ${menuOpen ? "open" : ""}`}>
            <li><NavLink to="/" onClick={closeMenu}>Home</NavLink></li>
            <li><NavLink to="/about" onClick={closeMenu}>About Us</NavLink></li>
            <li><NavLink to="/services" onClick={closeMenu}>Our Services</NavLink></li>
            <li><NavLink to="/fpo" onClick={closeMenu}>FPO</NavLink></li>
            <li><NavLink to="/blogs" onClick={closeMenu}>Blogs</NavLink></li>
            <li><NavLink to="/gallery" onClick={closeMenu}>Gallery</NavLink></li>
            <li><NavLink to="/contact" onClick={closeMenu}>Contact Us</NavLink></li>

            {/* MOBILE CTA */}
            <li className="dentas-mobile-cta">
              <NavLink
                to="/contact"
                onClick={closeMenu}
                className="dentas-get-btn"
              >
                GET IN TOUCH
              </NavLink>
            </li>
          </ul>

          {/* DESKTOP CTA */}
          <NavLink to="/contact" className="dentas-get-btn dentas-desktop-cta">
            GET IN TOUCH
          </NavLink>

          {/* HAMBURGER */}
          <div
            className={`dentas-hamburger ${menuOpen ? "active" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </nav>
    </>
  );
}
